import { h } from "preact"
import { VersionProvider } from "./components/VersionProvider"
import Login from "./views/login"

export default function App() {
    return (
        <VersionProvider>
            <Login />
        </VersionProvider>
    )
}
